import { SEO } from '../../lib/seo';

export function RecordsPageSEO() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "World Records - Furthest Distance Views",
    "description": "Discover the world records for furthest distance line-of-sight views on Earth. Browse champions by overall distance, skyline views, continents, and countries.",
    "url": "https://theviewshed.com/records"
  };

  return (
    <SEO
      title="World Records - Furthest Distance Views | TheViewShed"
      description="Explore the world records for furthest line-of-sight views. Champions include overall distance records, skyline views, continental records, and country records."
      keywords="world records, furthest views, distance records, skyline records, line of sight records, viewshed records, longest views, ultra long distance"
      structuredData={structuredData}
    />
  );
}
